import { render, staticRenderFns } from "./error-block.html?vue&type=template&id=2406620f&scoped=true&"
import script from "./error-block.js?vue&type=script&lang=js&"
export * from "./error-block.js?vue&type=script&lang=js&"
import style0 from "./error-block.scss?vue&type=style&index=0&id=2406620f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406620f",
  null
  
)

export default component.exports